import { FormattedMessage } from "react-intl";
import DownloadIconSmall from "../../../../components/Common/SvgIcons/CommonIcons/DownloadIconSmall";
import Tooltip from "../../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../../tableColumnTypes";
import { engagementCenter } from "./engagementCenter";

export const notificationHistory = {
  name: <FormattedMessage id="NOTIFICATION_HISTORY" />,
  path: (tenantName) => engagementCenter.notificationHistoryPath(tenantName),
  navLinks: (navigate, tenantName) => [
    ...engagementCenter.navLinks(navigate, tenantName),
    {
      key: 3,
      label: notificationHistory.name,
      path: notificationHistory.path(tenantName),
      onClick: () => navigate(notificationHistory.path(tenantName)),
    },
  ],
  columns: (handleNotificationDownload) => [
    {
      ID: 1,
      name: <FormattedMessage id="NOTIFICATION_TEXT" />,
      fieldName: "NotificationName",
      value: (row) => row.NotificationName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: "Target users",
      fieldName: "NotifiedUsers",
      value: (row) => row.NotifiedUsers,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="STATUS_TEXT" />,
      fieldName: "Status",
      value: (row) => row.Status,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="NOTIFIED_ON" />,
      fieldName: "NotifiedOn",
      value: (row) => new Date(row.NotifiedOn).toLocaleString(),
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 5,
      name: <FormattedMessage id="MYCLASS_ACTIONS" />,
      fieldName: "",
      value: (row) => (
        <>
          <Tooltip
            content={<FormattedMessage id="DOWNLOAD_CONTENT" />}
            direction={"bottom"}
            // show={row?.IsActive && row?.IsEventBase}
          >
            <span
              //   style={{
              //     visibility:
              //       row?.IsActive && row?.IsEventBase ? "visible" : "hidden",
              //   }}
              onClick={() => handleNotificationDownload(row)}
            >
              <DownloadIconSmall />
            </span>
          </Tooltip>
        </>
      ),
      sort: false,
    },
  ],
};
